module.exports = __webpack_public_path__ + "img/delano.5c4e9a3f.webp";